import { render, staticRenderFns } from "./MentionableIncident.vue?vue&type=template&id=58532dda&scoped=true&"
import script from "./MentionableIncident.vue?vue&type=script&lang=js&"
export * from "./MentionableIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58532dda",
  null
  
)

export default component.exports